import Typography from '@alltrails/shared/denali/components/Typography';
import StatusBadge from '@alltrails/shared/denali/components/StatusBadge';
import * as styles from './styles/styles.module.scss';
import type FooterLinksType from '../../../utils/generators/FooterLinksType';

const FooterLinks = ({ href, title, testId, logAmplitudeEvent, childLinks = [] }: FooterLinksType) => (
  <div className={styles.container}>
    <div className={styles.title}>
      <a
        href={href}
        data-testid={testId}
        onClick={() => {
          if (logAmplitudeEvent) {
            logAmplitudeEvent();
          }
        }}
      >
        <Typography component="h2" variant="text300bold" color="inverse">
          {title}
        </Typography>
      </a>
    </div>
    <ul>
      {childLinks.map(link => (
        <li key={link.title} className={styles.childLink}>
          <a
            data-testid={link.testId}
            href={link.href}
            {...(link.openInNewWindow ? { target: '_blank' } : {})}
            onClick={() => {
              if (link.logAmplitudeEvent) {
                link.logAmplitudeEvent();
              }
            }}
          >
            {link.title}
          </a>
          {link.badge && <StatusBadge text={link.badge.text} variant={link.badge.variant} size={link.badge.size} />}
        </li>
      ))}
    </ul>
  </div>
);
export default FooterLinks;
